import React, { useEffect } from "react"

import useCategoryStore from "../../../data/categoryStore"
import useOneGameStore from "../../../data/oneGameStore"
import useTeamStore from "../../../data/teamStore"

export default function CategorySelection({
    view = "slideshow",
    handleCategoryClick,
    handleTeamClick = () => {},
}) {
    const game = JSON.parse(localStorage.getItem("smt-game"))
    const currentSlide = game?.currentSlide
    const currentRound = useOneGameStore(state =>
        state.getCurrentRoundBySlide(currentSlide)
    )

    // Get all teams and their scores
    const teams = game?.teams || []
    const teamScores = teams.map(team => {
        const totalScore = team.scores.reduce((acc, score) => {
            return acc + score.questions.filter(q => q.correct).length
        }, 0)
        return {
            team: team.team,
            displayName: team.displayName,
            score: totalScore,
        }
    })

    // Get teams that have already picked categories
    const teamsThatPicked =
        game?.rounds
            ?.filter(round => round.round < currentRound)
            .map(round => round.team) || []

    // Sort teams by score (lowest first)
    const sortedTeams = [...teamScores].sort((a, b) => a.score - b.score)

    // Find the next team to pick
    let nextTeamToPick = null
    for (const team of sortedTeams) {
        // Count how many times this team has picked
        const timesPicked = teamsThatPicked.filter(t => t === team.team).length

        // Count how many times other teams have picked
        const otherTeamsPicked = teamsThatPicked.filter(
            t => t !== team.team
        ).length

        // Team can pick if:
        // 1. They haven't picked yet, OR
        // 2. They've picked once but every other team has picked at least once
        if (
            timesPicked === 0 ||
            (timesPicked === 1 && otherTeamsPicked >= teams.length - 1)
        ) {
            nextTeamToPick = team
            break
        }
    }

    const alreadySelectedCategories =
        (game?.rounds && game?.rounds.map(round => round.category)) || []

    useEffect(() => {
        useOneGameStore.getState().refreshGame()
    }, [])

    return (
        <div className="slide category-selection-slide">
            {useCategoryStore
                .getState()
                .categories.filter(c => c.active)
                .map((category, index) => {
                    return (
                        <div
                            key={index}
                            className={`category-selection-item ${category.name
                                .toLowerCase()
                                .replace(" ", "-")}-background-transparent ${
                                alreadySelectedCategories.includes(category.id)
                                    ? "disabled"
                                    : ""
                            }`}
                            onClick={() => {
                                if (nextTeamToPick) {
                                    handleCategoryClick(
                                        category.id,
                                        nextTeamToPick.team
                                    )
                                }
                            }}
                        >
                            <span className="category-selection-name">
                                {category.name}
                            </span>
                        </div>
                    )
                })}
            <div
                className="category-selection-item selected-team"
                onClick={() => {
                    if (view === "liveScoring") {
                        handleTeamClick()
                    }
                }}
            >
                <span className="selected-team-name">
                    {nextTeamToPick
                        ? nextTeamToPick.displayName ||
                          useTeamStore
                              .getState()
                              .teams.find(t => t.id === nextTeamToPick.team)
                              ?.name
                        : "No team available to pick"}
                </span>
            </div>
        </div>
    )
}
